<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  >
    <div v-if="welcomeOffers.length">
      <div class="offer-header plr16">
        <h1 class="offer">{{ title }}</h1>
        <span class="view-all-cta" @click="triggerOfferListing()">
          {{ viewAllCta }}
        </span>
      </div>
      <div class="payment-offer-wrap pt12 mb24 low-gap dt-mb48">
        <div
          class="custom-offer-carousel w-container"
          :class="welcomeOffers.length > 1 ? 'pr8 pl16' : ''"
        >
          <Carousel
            :pauseAutoplayOnHover="true"
            :transition="500"
            :touchDrag="false"
            :mouseDrag="false"
            :settings="settings"
            :breakpoints="breakpoints"
          >
            <Slide
              :class="welcomeOffers.length > 1 ? 'pr16' : 'full-width-card'"
              v-for="(item, index) in welcomeOffers"
              :key="item?.id"
            >
              <offer-card
                :data-index="index"
                :data-title="item.metaData.name"
                :data-promo-code="item.couponCode"
                :data-description="item.metaData.description"
                :data-item-tnc="item.campaignId"
                :data-discount="discount"
              ></offer-card>
            </Slide>
            <template #addons v-if="clientPlatform == 'Web'">
              <Navigation />
            </template>
          </Carousel>
        </div>
      </div>

      <!-- offer details popup -->
      <offer-details-popup
        v-if="offerDetailsModalFlag"
        :data-title="welcomeOffers[selectedOfferIndex]?.metaData?.name"
        :data-description="
          welcomeOffers[selectedOfferIndex]?.metaData?.description
        "
        :data-coupon-code="welcomeOffers[selectedOfferIndex]?.couponCode"
        :data-expiry-date="welcomeOffers[selectedOfferIndex]?.expiryDate"
        :data-savings-msg="
          welcomeOffers[selectedOfferIndex]?.metaData?.savingsMessage
        "
      ></offer-details-popup>

      <!-- offer applied popup --- when card is not selected-->
      <generic-modal
        v-if="showOfferAppliedModal"
        @close="closeAppliedModal()"
        :height="'auto'"
        :width="'100vw'"
        :padding="'0px'"
        :borderRadius="'8px'"
        class="d-flex justify-content-center align-items-center plr40"
        :class="[
          clientPlatform == 'Web'
            ? 'lg-screen-centered sticky-bottom show'
            : '',
        ]"
      >
        <template v-slot:header>
          <div class="handle-wrap positionselectediconhomepage">
            <img
              :src="staticImgBaseUrl + '/images/global/offerSelectedIcon.svg'"
              class="offerselectedicon"
            />
          </div>
        </template>
        <template v-slot:body>
          <div class="full-screen-popup offer-confetti" v-if="showLottie">
            <VueLottiePlayer
              name="confettiAnim"
              width="100%"
              height="100%"
              :animationData="require('../assets/ConfettiOrderSuccessful.json')"
            />
          </div>
          <div class="ms-offer-pop-content">
            <offer-selected-popup
              :data-title="appliedOfferPromo + ' Selected'"
              :data-description="getDataDescription"
              :data-action="'Woohoo! Thanks'"
              :data-padding-left="clientPlatform == 'Web' ? '16vw' : '30vw'"
            ></offer-selected-popup>
          </div>
        </template>
        <template v-slot:footer>
          <div></div>
        </template>
      </generic-modal>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import {
  imgBaseUrl,
  staticImgBaseUrl,
  clientPlatform,
} from "../config/apiEndpoints";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import OfferCard from "./OfferCard.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { EVENT_CLICK_APPLYOFFERSUCCESS } from "../helpers/analyticsEvents";
import "vue3-carousel/dist/carousel.css";

export default {
  name: "Offers",
  components: {
    Carousel,
    Slide,
    Navigation,
    OfferDetailsPopup: defineAsyncComponent(() =>
      import("./OfferDetailsPopup.vue")
    ),
    OfferCard,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      offerlist: [
        "On the application of the deal code WELCOME120, discount will automatically be deducted from the booking amount.",
        "On the application of the deal code LAH50, discount will automatically be ",
      ],
      offerlistModal: {
        width: "100vw",
        height: "100%",
        modalClass: "full-screen-popup",
      },
      staticImgBaseUrl: staticImgBaseUrl,
      imgBaseUrl: imgBaseUrl,
      sessionDependedMethodsProcessed: false,
      clientPlatform,
      showLottie: false,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
      modulePropsData: {},
      title: "Offers",
      viewAllCta: "View All",
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.title = this.modulePropsData?.title;
    this.viewAllCta = this.modulePropsData?.viewAllCta;
    LocalStorageFunc.setPrevUrl(window.location.href);
    this.$store.commit(
      keyMapsMutation.UPDATE_OFFER_APPLY_MODAL,
      JSON.parse(LocalStorageFunc.getOfferAppliedModal())
    );
    setTimeout(this.closeAppliedModal, 3000);

    this.$store.commit(
      keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
      LocalStorageFunc.getCouponCode()?.code
    );
  },
  updated() {
    if (JSON.parse(LocalStorageFunc.getOfferAppliedModal())) {
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_APPLY_MODAL,
        JSON.parse(LocalStorageFunc.getOfferAppliedModal())
      );
      setTimeout(this.closeAppliedModal, 3000);

      this.$store.commit(
        keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
        LocalStorageFunc.getCouponCode()?.code
      );
    }
  },
  methods: {
    triggerOfferListing() {
      Utility.sendToOffersScreen();
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");

      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false
      );
    },
  },
  computed: {
    welcomeOffers() {
      return this.$store.state.Offers.offersList;
    },
    appliedOfferPromo() {
      return this.$store.state.Offers.appliedOfferPromo;
    },
    offerDetailsModalFlag() {
      return this.$store.state.Offers.offerDetailsModalFlag;
    },
    selectedOfferIndex() {
      return this.$store.state.Offers.selectedOfferIndex;
    },
    selectedOfferTnc() {
      return this.$store.state.Offers.selectedOfferTnc;
    },
    isViewAllSelected() {
      return this.$store.state.Offers.isViewAllOffersSelected;
    },
    getDataDescription() {
      return this.welcomeOffers.find(
        (x) => x.couponCode === this.appliedOfferPromo
      )?.metaData?.savingsMessage;
    },
    showOfferAppliedModal() {
      setTimeout(() => LocalStorageFunc.setOfferAppliedModal(false), 3000);
      let isOfferAppliedModal = this.$store.state.Offers.isOfferAppliedModal;
      if (isOfferAppliedModal) {
        EVENT_CLICK_APPLYOFFERSUCCESS({
          subCategory: "popup shown",
          sectionPosition: 1,
          positionWithinSection:
            this.$store.state.Offers.selectedOfferIndex + 1,
          category: this.$store.state.Offers.appliedOfferPromo,
          cartValue: this.$store.getters[keyMapsGetter.CART_TOTAL],
          couponCode: this.$store.state.Offers.appliedOfferPromo,
          couponIndex: this.$store.state.Offers.selectedOfferIndex + 1,
        });
      }
      if (isOfferAppliedModal) {
        this.showLottie = true;
        setTimeout(() => {
          this.showLottie = false;
        }, 1000);
      }
      return isOfferAppliedModal;
    },
    discount() {
      return this.$store.state.Offers.discount;
    },
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP && !this.sessionDependedMethodsProcessed) {
        this.$store.dispatch(keyMapsAction.WELCOME_OFFER_API, true);
        // this.$store.dispatch(keyMapsAction.PAYMENT_OFFER_API, {});
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
  },
};
</script>

<style></style>
